import { LineageMetric, RawLineageMetric } from "./Finance.model";

const unwrapDatum = (maybeWrapped: any) => {
    if (maybeWrapped && "value" in maybeWrapped && maybeWrapped.value?.meta) {
        return maybeWrapped.value;
    }
    return maybeWrapped;
};

export default function parseLineageMetric(
    raw: RawLineageMetric,
): LineageMetric {
    return {
        description: raw.description,
        info: raw.info,
        lineagedValues: raw.lineagedValues.map((lineagedValue) => {
            const accountDatums =
                "add" in lineagedValue.expr
                    ? lineagedValue.expr.add
                    : "value" in lineagedValue.expr
                      ? [lineagedValue.expr.value]
                      : [];

            return {
                period: lineagedValue.period,
                value: lineagedValue.value,
                accounts: accountDatums.map((item) => {
                    const datum = unwrapDatum(item);
                    return {
                        value: datum.value.number,
                        dataAssetId: datum.meta.dataAssetId,
                        accountId: datum.meta.accountId,
                    };
                }),
            };
        }),
    };
}
